import { render, staticRenderFns } from "./LLTag.vue?vue&type=template&id=39b6ec4c&scoped=true"
import script from "./LLTag.vue?vue&type=script&lang=js"
export * from "./LLTag.vue?vue&type=script&lang=js"
import style0 from "./LLTag.vue?vue&type=style&index=0&id=39b6ec4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b6ec4c",
  null
  
)

export default component.exports